// Mirror of Portal-BE app/warehouse/components/passwordBlocklist.js — keep in step.
// Compared after normalisation in passwordStrength.ts (lowercase, symbols
// stripped, edge digits stripped, leet-folded). Lowercase alphanumeric only.

export const COMMON_PASSWORDS: readonly string[] = [
    // English
    "password", "passwords", "passw0rd", "password1", "password123", "qwerty", "qwerty123", "qwertyuiop",
    "letmein", "welcome", "welcome1", "admin", "admin123", "administrator", "root", "toor", "login", "logon",
    "master", "dragon", "monkey", "football", "baseball", "soccer", "hockey", "iloveyou", "sunshine",
    "princess", "shadow", "superman", "batman", "trustno1", "hello", "hello123", "abc123", "abcd1234",
    "a1b2c3d4", "1q2w3e4r", "1q2w3e4r5t", "1qaz2wsx", "zaq12wsx", "qazwsx", "qazwsxedc", "asdfgh", "asdfghjkl",
    "zxcvbn", "zxcvbnm", "123456", "1234567", "12345678", "123456789", "1234567890", "111111", "000000",
    "123123", "654321", "696969", "121212", "112233", "123321", "changeme", "secret", "secret1", "test",
    "test123", "testing", "user", "guest", "default", "temp", "temp123", "temporary", "letmein1", "whatever",
    "freedom", "starwars", "pokemon", "computer", "internet", "samsung", "google", "charlie", "michael",
    "jennifer", "summer", "winter", "spring", "autumn", "january", "december", "liverpool", "arsenal",
    "chelsea", "manchester",
    // Polish
    "haslo", "haslo1", "haslo123", "polska", "polska1", "kochanie", "kochanie1", "misiek", "kotek", "piesek",
    "slonce", "slonce1", "mateusz", "michal", "kasia", "agnieszka", "marcin", "krzysiek", "warszawa", "krakow",
    "wroclaw", "legia", "wisla", "lechia", "komputer", "tajne", "zdzich", "kasztan", "misiaczek", "gwiazda",
    // Portal / JLI
    "portal", "portal1", "portal123", "warehouse", "warehouse1", "jli", "jlitrading", "jobalots", "bargainfox",
    "pembroke", "newport", "poland",
];

export const KEYBOARD_ROWS: readonly string[] = ["qwertyuiop", "asdfghjkl", "zxcvbnm", "1234567890"];
